import type { InsertPoentialHighQuality } from '@hvf/contracts'
import { user } from '@stateApp' // Assuming 'user' is exported from your stateApp barrel
import { createQuery, useMutation } from '@tanstack/solid-query'
import {
	confirmPotentialHighQualityRpc,
	createPotentialHighQualityPost,
	handleGetPotentialHighQuality,
} from './resource'

export function usePotentialHighQuality() {
	const createPhqMutation = useMutation(() => ({
		mutationFn: (data: InsertPoentialHighQuality) =>
			createPotentialHighQualityPost(data),
	}))

	const confirmPhqMutation = useMutation(() => ({
		mutationFn: (setupId: string) => confirmPotentialHighQualityRpc(setupId),
	}))

	// NEW: Manage the fetching state of Potential High Quality setups
	const potentialHighQualityQuery = createQuery(() => ({
		queryKey: ['potentialHighQuality', user()?.user.id],
		queryFn: () => handleGetPotentialHighQuality(user()?.user.id as string),
		enabled: !!user()?.user.id,
	}))

	return {
		createPhqMutation,
		confirmPhqMutation,
		potentialHighQualityQuery,
	}
}
